import { lazy } from 'react'
import type { Routes } from '@/@types/routes'
const Empid = lazy(() => import('@/views/auth/empid/components/Empid'));
const Empid_v2 = lazy(() => import('@/views/auth/empid_v2/components/Empid_v2'));
const Empid_v3 = lazy(() => import('@/views/auth/empid_v3/components/Empid_v3_page'));
const Empid_v4 = lazy(() => import('@/views/auth/empid_v4/components/Empid_v4_page'));
const Empid_v5 = lazy(() => import('@/views/auth/empid_v5/components/Empid_v5_page'));

const RegistrationForm = lazy(() => import('@/views/auth/Registration/components/RegistrationForm'));
const HomePage = lazy(() => import('@/views/auth/Home/components/HomePage'));
const LandingPage = lazy(() => import('@/views/auth/LandingPage/components/LandingPage'));
const ContactPage = lazy(() => import('@/views/auth/Contact/components/ContactForm'));
const PrivacyPolicyPage = lazy(() => import('@/views/auth/PrivacyPolicy/components/PrivacyPolicy'));
const ScheduleAppointmentPage = lazy(() => import('@/views/auth/ScheduleAppointment/components/ScheduleAppointmentForm'));
const AppointmentPage = lazy(() => import('@/views/auth/ScheduleAppointment/components/AppointmentForm'));
const RegistrationRequest = lazy(() => import('@/views/auth/RegistrationRequest'));
const OTPLogin = lazy(() => import('@/views/auth/OtpLogin'));
const QRLogin = lazy(() => import('@/views/auth/QRLogin'));
const ResetOtp = lazy(() => import('@/views/auth/ResetOtp'));
const SendOtp = lazy(() => import('@/views/auth/SendOtp'));
const ResetPassword = lazy(() => import('@/views/auth/ResetPassword'));
const ForgotPassword = lazy(() => import('@/views/auth/ForgotPassword'));
const SignUp = lazy(() => import('@/views/auth/SignUp'));
const SignIn = lazy(() => import('@/views/auth/SignIn'));
const SignInV2 = lazy(() => import('@/views/auth/SignInV2'));
const LeaveRequestApproval = lazy(() => import('@/views/auth/LeaveRequestApproval'));
const leaverequestOTP = lazy(() => import('@/views/auth/LeaveRequestOtp'));
const attendanceRequestApproval = lazy(() => import('@/views/auth/AttendanceRequestApproval'));
const attendanceRequestOTP = lazy(() => import('@/views/auth/AttendanceRequestOtp'));
const RegFace = lazy(() => import('@/views/auth/RegFace'));
const VisitorQR = lazy(() => import('@/views/auth/VisitorQR'));
const VisitorRegister = lazy(() => import('@/views/auth/VisitorRegister'));

const authRoute: Routes = [
    {
        key: 'signIn',
        path: `/sign-in`,
        component: SignIn,
        authority: [],
    },
    {
        key: 'signInV2',
        path: `/sign-in-v2`,
        component: SignInV2,
        authority: [],
    },
    {
        key: 'signUp',
        path: `/sign-up`,
        component: SignUp,
        authority: [],
    },
    {
        key: 'forgotPassword',
        path: `/forgot-password`,
        component: ForgotPassword,
        authority: [],
    },
    {
        key: 'resetPassword',
        path: `/reset-password`,
        component: ResetPassword,
        authority: [],
    },
    {
        key: 'sendotp',
        path: `/sendotp`,
        component: SendOtp,
        authority: [],
    },
    {
        key: 'resetOtp',
        path: `/resetotp`,
        component: ResetOtp,
        authority: [],
    },
    // {
    //     key: 'qrlogin',
    //     path: `/qrlogin`,
    //     component: lazy(() => import('@/views/auth/QRLogin')),
    //     authority: [],
    // },
    {
        key: 'qrlogin',
        path: '/qrlogin',
        component: QRLogin,
        authority: [],
    },
    {
        key: 'otplogin',
        path: '/otplogin',
        component: OTPLogin,
        authority: [],
    },
	{
	    key: 'registrationrequest',
	    path: '/registrationrequest',
	    component: RegistrationRequest,
	    authority: [],
	},	
	{
	    key: 'home',
	    path: '/home',
	    component: HomePage,
	    authority: [],
	},
	{
	    key: 'homev2',
	    path: '/homev2',
	    component: LandingPage,
	    authority: [],
	},
	{
	    key: 'contact',
	    path: '/contact',
	    component: ContactPage,
	    authority: [],
	},
	{
	    key: 'privacypolicy',
	    path: '/privacy-policy',
	    component: PrivacyPolicyPage,
	    authority: [],
	},
	{
	    key: 'scheduleappointment',
	    path: '/scheduleappointment',
	    component: ScheduleAppointmentPage,
	    authority: [],
	},
	{
	    key: 'appointment',
	    path: '/appointment',
	    component: AppointmentPage,
	    authority: [],
	},
	{
	    key: 'registration',
	    path: '/organization/registration',
	    component: RegistrationForm,
	    authority: [],
	},	
	{
	    key: 'empid',
	    path: '/empeid/:id/:token',
	    component: Empid,
	    authority: [],
	},	
	{
	    key: 'empid_v2',
	    path: '/empeid_v2',
	    component: Empid_v2,
	    authority: [],
    },
	{
	    key: 'empid_v3',
	    path: '/empeid_v3',
	    component: Empid_v3,
	    authority: [],
    },
	{
	    key: 'empid_v4',
	    path: '/empeid_v4',
	    component: Empid_v4,
	    authority: [],
    },
	{
	    key: 'empid_v5',
	    path: '/empeid_v5',
	    component:Empid_v5,
	    authority: [],
    },
	{
	    key: 'viewdetails',
	    path: '/viewdetails',
	    component: LeaveRequestApproval,
	    authority: [],
	},
	{
	    key: 'viewrequestdetails',
	    path: '/viewrequestdetails',
	    component: leaverequestOTP,
	    authority: [],
	},
	{
	    key: 'attendancerequest',
	    path: '/attendancerequestapproval',
	    component: attendanceRequestApproval,
	    authority: [],
	},
	{
	    key: 'attendancerequestotp',
	    path: '/attendancerequestotp',
	    component: attendanceRequestOTP,
	    authority: [],
	},
	{
	    key: 'regface',
	    path: '/reg_face',
	    component: RegFace,
	    authority: [],
	}
    // {
    //     key: 'changePassword',
    //     path: `/change-password`,
    //     component: lazy(() => import('@/views/auth/ChangePassword')),
    //     authority: [],
    // },
    // {
    //     key: 'changeOTP',
    //     path: `/change-otp`,
    //     component: lazy(() => import('@/views/auth/ChangeOtp')),
    //     authority: [],
    // }
]

// Public visitor self-registration:
//   /visitor/qr        shows the QR code on the screen at the gate
//   /visitor/register  the visitor entry form the QR code opens
// Kept out of authRoute on purpose: AllRoutes renders these outside both route
// guards, so they work with or without a session (PublicRoute would otherwise
// bounce a phone that still holds an employee login straight to the app home).
export const visitorRoutes: Routes = [
    {
        key: 'visitorqr',
        path: '/visitor/qr',
        component: VisitorQR,
        authority: [],
    },
    {
        key: 'visitorregister',
        path: '/visitor/register',
        component: VisitorRegister,
        authority: [],
    },
]

export default authRoute
